"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 * @param core The EditorCore object
 * @param forceGetStateFromDOM If set to true, will force get the format state from DOM tree.
 * @returns The cached format state if it exists. If the cached postion do not exist, search for pendable elements in the DOM tree and return the pendable format state.
 */
exports.getPendableFormatState = function (core, forceGetStateFromDOM) {
    var _a;
    var range = core.api.getSelectionRange(core, true /* tryGetFromCache*/);
    var cachedPendableFormatState = core.pendingFormatState.pendableFormatState;
    var cachedPosition = (_a = core.pendingFormatState.pendableFormatPosition) === null || _a === void 0 ? void 0 : _a.normalize();
    var currentPosition = range && roosterjs_editor_dom_1.Position.getStart(range).normalize();
    var isSamePosition = currentPosition && range.collapsed && currentPosition.equalTo(cachedPosition);
    if (range && cachedPendableFormatState && isSamePosition && !forceGetStateFromDOM) {
        return cachedPendableFormatState;
    }
    else {
        return currentPosition ? queryCommandStateFromDOM(core, currentPosition) : {};
    }
};
var PendableStyleCheckers = {
    isBold: function (tag, style) {
        return tag == 'B' ||
            tag == 'STRONG' ||
            parseInt(style.fontWeight) >= 700 ||
            ['bold', 'bolder'].indexOf(style.fontWeight) >= 0;
    },
    isUnderline: function (tag, style) { return tag == 'U' || style.textDecoration.indexOf('underline') >= 0; },
    isItalic: function (tag, style) { return tag == 'I' || tag == 'EM' || style.fontStyle === 'italic'; },
    isSubscript: function (tag, style) { return tag == 'SUB' || style.verticalAlign === 'sub'; },
    isSuperscript: function (tag, style) { return tag == 'SUP' || style.verticalAlign === 'super'; },
    isStrikeThrough: function (tag, style) {
        return tag == 'S' || tag == 'STRIKE' || style.textDecoration.indexOf('line-through') >= 0;
    },
};
/**
 * CssFalsyCheckers checks for non pendable format that might overlay a pendable format, then it can prevent getPendableFormatState return falsy pendable format states.
 */
var CssFalsyCheckers = {
    isBold: function (style) {
        return (style.fontWeight !== '' && parseInt(style.fontWeight) < 700) ||
            style.fontWeight === 'normal';
    },
    isUnderline: function (style) {
        return style.textDecoration !== '' && style.textDecoration.indexOf('underline') < 0;
    },
    isItalic: function (style) { return style.fontStyle !== '' && style.fontStyle !== 'italic'; },
    isSubscript: function (style) { return style.verticalAlign !== '' && style.verticalAlign !== 'sub'; },
    isSuperscript: function (style) { return style.verticalAlign !== '' && style.verticalAlign !== 'super'; },
    isStrikeThrough: function (style) {
        return style.textDecoration !== '' && style.textDecoration.indexOf('line-through') < 0;
    },
};
function queryCommandStateFromDOM(core, currentPosition) {
    var node = currentPosition.node;
    var formatState = {};
    var pendablekeys = [];
    var _loop_1 = function () {
        var tag = roosterjs_editor_dom_1.getTagOfNode(node);
        var style = node.nodeType == 1 /* Element */ && node.style;
        if (tag && style) {
            Object.keys(PendableStyleCheckers).forEach(function (key) {
                if (!(pendablekeys.indexOf(key) >= 0)) {
                    formatState[key] = formatState[key] || PendableStyleCheckers[key](tag, style);
                    if (CssFalsyCheckers[key](style)) {
                        pendablekeys.push(key);
                    }
                }
            });
        }
        node = node.parentNode;
    };
    while (roosterjs_editor_dom_1.contains(core.contentDiv, node)) {
        _loop_1();
    }
    return formatState;
}
//# sourceMappingURL=getPendableFormatState.js.map